'use client';

import { useEffect } from 'react';

export default function RegisterServiceWorker() {
  useEffect(() => {
    // Never register the service worker inside the Capacitor native shell.
    // The app updates through the app store, not via SW; registering it in
    // the webview triggers blocking confirm() dialogs and controllerchange
    // reload loops (UpdatePrompt already handles native update prompts).
    const isNative =
      typeof window !== 'undefined' &&
      !!(window as any).Capacitor?.isNativePlatform?.();
    if (isNative) return;

    if ('serviceWorker' in navigator) {
      navigator.serviceWorker
        .register('/sw.js')
        .then((registration) => {
          console.log(' Service Worker registered:', registration.scope);
          
          // Check for updates
          registration.addEventListener('updatefound', () => {
            const newWorker = registration.installing;
            if (newWorker) {
              newWorker.addEventListener('statechange', () => {
                if (newWorker.state === 'installed' && navigator.serviceWorker.controller) {
                  // New service worker available
                  if (confirm('New version available! Reload to update?')) {
                    window.location.reload();
                  }
                }
              });
            }
          });
        })
        .catch((error) => {
          console.error(' Service Worker registration failed:', error);
        });

      // Handle controller change
      navigator.serviceWorker.addEventListener('controllerchange', () => {
        window.location.reload();
      });
    }

    // PWA install prompt
    let deferredPrompt: any;
    
    window.addEventListener('beforeinstallprompt', (e) => {
      e.preventDefault();
      deferredPrompt = e;
      
      // Show custom install button (we can add this to UI later)
      console.log('� PWA install available');
      
      // Store for later use
      (window as any).deferredPrompt = deferredPrompt;
    });

    window.addEventListener('appinstalled', () => {
      console.log(' PWA installed successfully');
      deferredPrompt = null;
    });
  }, []);

  return null;
}

